import { render, staticRenderFns } from "./AuthLogoBanner.vue?vue&type=template&id=678095b4&"
import script from "./AuthLogoBanner.vue?vue&type=script&lang=js&"
export * from "./AuthLogoBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports